import { render, staticRenderFns } from "./RejectionBtn.vue?vue&type=template&id=b3463a18"
import script from "./RejectionBtn.vue?vue&type=script&lang=ts"
export * from "./RejectionBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports